import { Translate as t } from '../config/Translate';

// IMP-468 (#507): BE 는 필드 중복을 `EU0004` + `errors: [{ name, msg }]` 로 돌려주고,
// Inputs.js 가 `errs.filter(x => x.name === options.name)` 로 찾아 `msg` 를 **그대로** 렌더한다.
// 그런데 그 `msg` 는 핸들러에 하드코딩된 단일 언어 문자열이라 어떤 로케일에서도 같은 문구가 뜬다.
// (RAYGuard 는 유럽 법인 사용자가 많고, 이메일 중복은 바로 그 계정들에서 주로 발생한다.)
//
// 그래서 FE 가 `name` 을 키로 지역화 문구를 덮어쓴다. 매핑에 없는 항목은 서버 `msg` 를 그대로
// 둔다 — 새 에러가 추가돼도 문구가 사라지지 않게 하기 위한 것이다.
const FIELD_ERROR_KEYS = {
    email: 'user.message.error.duplicateEmail',
    adminid: 'user.message.error.duplicateAdminid',
};

export const localizeUserFormErrors = (errors) => {
    if (!Array.isArray(errors)) return [];
    return errors.map((e) => {
        const key = e && FIELD_ERROR_KEYS[e.name];
        return key ? { ...e, msg: t(key) } : e;
    });
};

export default localizeUserFormErrors;
